import { Switch as HeadlessSwitch } from '@headlessui/react'
import classNames from 'classnames'

type Props = {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (value: boolean) => void
  name?: string
  value?: string
  className?: string
  disabled?: boolean
  onClick?: VoidFunction
}

export const Switch = ({ checked, className, ...props }: Props) => {
  return (
    <HeadlessSwitch
      {...props}
      className={classNames(
        'relative ml-3 h-6 w-12 min-w-[48px] cursor-pointer rounded-full bg-cool-400 transition-colors duration-200 ease-in-out md:ml-0',
        className
      )}
    >
      <span className='sr-only'>{checked ? 'Enable' : 'Disable'}</span>

      <span
        className={classNames(
          'bg-white absolute left-0.5 top-1/2 inline-block h-5 w-5 -translate-y-1/2 transform  rounded-full transition-all duration-300 ease-in-out',
          checked ? 'translate-x-6 bg-cool-200' : ' bg-cool-150'
        )}
      />
    </HeadlessSwitch>
  )
}
